import { defineStore } from 'pinia'
import { Posthog } from '@lingoking-node-apps/analytics'
import {
  type RegisterUser,
  registerCustomer as registerCustomerApi,
  type SocialRegisterUser,
  socialRegisterCustomerFinalize as socialRegisterCustomerFinalizeApi
} from '@/services/entities/Customer'

type RegisterCustomerStoreData = {
  error: any | null
  success: boolean
  loading: boolean
}

const createDefaultStoreData = (): RegisterCustomerStoreData => {
  return {
    error: null,
    success: false,
    loading: false
  }
}

export const useRegisterCustomerStore = defineStore({
  id: 'register-customer',
  state: (): RegisterCustomerStoreData => createDefaultStoreData(),
  actions: {
    async registerCustomer(data: RegisterUser) {
      this.$reset()
      this.loading = true

      return await registerCustomerApi(data)
        .then((response) => {
          this.loading = false
          this.success = true

          Posthog.capture.captureSuccessRegistration({})

          return Promise.resolve(response)
        })
        .catch((error) => {
          this.loading = false
          this.error = error

          return Promise.reject(error)
        })
    },
    async socialRegisterCustomerFinalize(data: SocialRegisterUser) {
      this.$reset()
      this.loading = true

      return await socialRegisterCustomerFinalizeApi(data)
          .then((response) => {
            this.loading = false
            this.success = true

            Posthog.capture.captureSuccessRegistration({})

            return Promise.resolve(response)
          })
          .catch((error) => {
            this.loading = false
            this.error = error

            return Promise.reject(error)
          })
    },
    reset() {
      this.$reset()
    }
  }
})
